import * as React from 'react';

import { HtmlContent as CommonHtmlContent } from '@dndbeyond/character-common-components/es';
import { FormatUtils } from '@dndbeyond/character-rules-engine/es';

interface Props {
    html: string;
    className: string;
}
export default class HtmlContent extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { className, html } = this.props;

        return <CommonHtmlContent className={className} html={FormatUtils.stripTooltipTags(html)} />;
    }
}
